<template>
    <div id="registryEditRulePanel" class="form-wrapper">

        <PanelDropdown v-model="localForm.registryHive" :label="$t('registryHive')" :options="registryHiveOptions"
            placeholder="None" :tooltip="tooltips.registryAccess.registryHive" />
        <PanelInput v-model="localForm.registryKey" :label="$t('registryKey')" placeholder="Enter Registry Key" :errorMessage="registryKeyError"
            :isInvalid="!!registryKeyError" :tooltip="tooltips.registryAccess.registryKey"/>
        <PanelInput v-model="localForm.registryValue" :label="$t('registryValue')" placeholder="Enter Registry Value" :tooltip="tooltips.registryAccess.registryValue" />
        <PanelDropdown v-model="localForm.accessControl" :label="$t('accessControl')" :options="accessControlOptions"
            placeholder="" :tooltip="tooltips.registryAccess.accessControl" />
        <PanelDropdown v-model="localForm.appliesTo" :label="$t('appliesTo')" :options="appliesToOptions" placeholder="" :tooltip="tooltips.registryAccess.appliesTo" />
        <ExpertNotes v-model="localForm.expertNotes" :max-length="1000" label="Expert Notes" />
    </div>
</template>

<script setup>
import { defineProps, ref, watch, defineEmits, computed } from 'vue'
import PanelInput from './components/panelInput.vue'
import PanelDropdown from './components/panelDropdown.vue'
import { useStore } from "@/store";
import ExpertNotes from './components/expertNotes.vue';
import tooltips from '@/assets/tooltips/en.json'

const props = defineProps({
    form: {
        type: Object,
        required: true,
    },
    formType: {
        type: String,
        default: 'registry'
    },
    enumKey: {
        type: String,
        default: 'AccessControl'
    }
})
const emit = defineEmits(['update:form'])
const store = useStore();
const registryKeyError = ref('');
const localForm = computed({
    get() {
        return props.form;
    },
    set(newVal) {
        emit('update:form', newVal);
    }
});

const accessControlOptions = computed(() => {
    return store.state.general.enums[props.enumKey] || [];
});

const appliesToOptions = computed(() => store.state.general.enums['AppliesTo'] || [])
const registryHiveOptions = computed(() => store.state.general.enums['RegistryHive'] || [])

const validateRegistryKey = (key) => {
    // if (!key) {
    //     return 'Registry key cannot be empty.';
    // }
     const forbiddenCharsRegex = /[/?"<>|]/;
    if (forbiddenCharsRegex.test(key)) {
        return 'Registry key name cannot contain the following characters: / * ? " < > | or control characters.';
    }
    return ''; 
};

watch(() => localForm.value.registryKey, (newVal) => {
    registryKeyError.value = validateRegistryKey(newVal);
}, { immediate: true });


</script>
<style>
.form-wrapper {
    font-size: 0.8rem !important;
}

.custom-input {
    width: inherit;
}

.boxed-group {
    width: inherit;
    border: 1px solid #dcdcdc;
    border-radius: 6px;
    padding: 12px;
    margin-right: 10px;

}

.label-check {
    margin-left: 5px;
    margin-bottom: 0px !important;
}

.form-label {
    color: #164B6C;
    font-weight: bold;
    margin-left: 8px;
}

.info-icon {
    margin-left: 3px;
}
</style>
